import React from 'react';
import { Link } from 'react-router-dom';

interface FormPageProps {
  backTo: string;
  backLabel: string;
  breadcrumb?: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  hint?: React.ReactNode;
}

const FormPage: React.FC<FormPageProps> = ({
  backTo,
  backLabel,
  breadcrumb,
  title,
  subtitle,
  children,
  footer,
  hint,
}) => (
  <div className="form-page">
    {breadcrumb && (
      <div className="breadcrumb" style={{ marginBottom: 4 }}>
        {breadcrumb}
      </div>
    )}
    <h1 className="page-title" style={{ marginBottom: 4 }}>
      {title}
    </h1>
    {subtitle && (
      <div className="page-subtitle" style={{ marginBottom: 16 }}>
        {subtitle}
      </div>
    )}
    <Link to={backTo} className="back-link">
      ← {backLabel}
    </Link>
    <div className="form-card">
      <div className="form-card-body">
        {hint && <div className="hint-banner">{hint}</div>}
        {children}
      </div>
      {footer && <div className="form-card-footer">{footer}</div>}
    </div>
  </div>
);

export default FormPage;
